// @flow
import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  img: string,
  title: string,
  date: string,
  slug: string,
  categorySlug: string,
  categoryName?: string
}

const NewsRow = (props: Props) => {
  return (
    <Link to={`/actualites/${props.categorySlug}/${props.slug}`} className="news news--row" title={`Lire la suite du contenu ${props.title}`}>
      <article>
        <div className="news__thumbnail img-blue" style={{backgroundImage: `url(${props.img})`}}>
          <img src={props.img} alt={`Illustration de ${props.title}`}/>
        </div>
        <div>
          <span className="news__title ft-h4">{props.title}</span>
          <p className="ft-h6">
            {props.categoryName && 
            <span className="news__cat ft-up">{props.categoryName}</span>}
            <span className="news__date">{props.date}</span>
          </p>
        </div>
      </article>
    </Link>
  );
};

export default NewsRow;
